export interface IThemeState {
  isLightMode: boolean;
  realizationIsEnabled: boolean;
}

export enum IThemeTypes {
  CHANGE_ACTIVE_THEME = 'CHANGE_ACTIVE_THEME',
  CHANGE_REALIZATION = 'CHANGE_REALIZATION',
}
